var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61272 0C7.11804 0 7.58364 0.274095 7.82896 0.71591L9.53056 3.78107C9.75335 4.1824 9.76385 4.66783 9.55852 5.07841L7.91925 8.35696C7.91925 8.35696 8.39431 10.7994 10.3825 12.7876C12.3707 14.7757 14.8049 15.2426 14.8049 15.2426L18.0829 13.6036C18.4938 13.3981 18.9796 13.4088 19.381 13.632L22.4549 15.3409C22.8964 15.5863 23.1701 16.0517 23.1701 16.5567V20.0856C23.1701 21.8827 21.5008 23.1807 19.798 22.6061C16.3009 21.4261 10.8723 19.1793 7.43153 15.7385C3.9907 12.2977 1.74393 6.86918 0.563919 3.37201C-0.0106278 1.66923 1.28733 0 3.0844 0H6.61272Z",
    fill: "#FFFFFF "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.fa13e786d6d081a074972e32a443179a.svg";
export { ForwardRef as ReactComponent };